module.exports = __webpack_public_path__ + "img/4_134.02638e43.png";